import SvgIcon from '@mui/material/SvgIcon';

export default function MinimizeIcon() {
  return (
    <SvgIcon>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 10.0021C2.02895 6.58807 2.21848 4.70599 3.45963 3.46485C4.92448 2 7.28212 2 11.9974 2C16.7127 2 19.0703 2 20.5352 3.46485C22 4.9297 22 7.28733 22 12.0026C22 16.7179 22 19.0755 20.5352 20.5404C19.294 21.7815 17.4119 21.9711 13.9979 22"
          stroke="#141B34"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.99871 13C3.82845 13.0351 3.13074 13.1652 2.64796 13.648C2.16519 14.1307 2.03507 14.8285 2 15.9987M8.00129 13C9.17155 13.0351 9.86926 13.1652 10.352 13.648C10.8348 14.1307 10.9649 14.8285 11 15.9987M11 19.0013C10.9649 20.1715 10.8348 20.8693 10.352 21.352C9.86926 21.8348 9.17155 21.9649 8.00129 22M4.99872 22C3.82846 21.9649 3.13074 21.8348 2.64796 21.352C2.16519 20.8693 2.03507 20.1715 2 19.0013"
          stroke="#141B34"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.4125 11.0056L13.5094 10.9387C13.0779 10.9288 12.7324 10.5944 12.7275 10.182L12.6963 7.538M20.028 3.76562L13.2806 10.3666"
          stroke="#141B34"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
